import React, { Component } from 'react';
import { Button } from 'react-toolbox';
import PropTypes from 'prop-types';
import styles from './styles.scss';

class Paginate extends Component {
  getNumOfPages = () => Math.ceil(this.props.totalCount / this.props.denominator);

  changePage = page => this.props.getListPage(page);

  isActive = num => (this.props.currentPage === num ? styles.active : '');

  prevNextPage = (next) => {
    const { currentPage } = this.props;
    if (next && currentPage < this.getNumOfPages()) this.changePage(currentPage + 1);
    else if (!next && currentPage > 1) this.changePage(currentPage - 1);
  }

  displayPageItems = () => {
    const html = [];
    const numOfPages = this.getNumOfPages();
    let outOfRange = false;
    for (let i = 1; i <= numOfPages; i += 1) {
      // Show the first page, last page, current page and 2 pages in front and behind current page
      if (i <= 1 || i >= numOfPages || Math.abs(i - this.props.currentPage) <= 2) {
        outOfRange = false;
        html.push(<Button
          key={i}
          type="button"
          className={`${styles[this.props.buttonStyle]} ${this.isActive(i)}`}
          label={i.toString()}
          onClick={() => this.changePage(i)}
        />);
      } else if (!outOfRange) {
        html.push(<Button
          key={i}
          type="button"
          className={`${styles[this.props.buttonStyle]} ${this.isActive(i)}`}
          label="..."
        />);
        outOfRange = true;
      }
    }
    return html;
  }

  render = () => (<div className={styles.paginationContainer}>
    <Button
      type="button"
      className={styles[this.props.buttonStyle]}
      label="Previous"
      onClick={() => this.prevNextPage(false)}
    />
    {this.displayPageItems()}
    <Button
      type="button"
      className={styles[this.props.buttonStyle]}
      label="Next"
      onClick={() => this.prevNextPage(true)}
    />
  </div>);
}

Paginate.defaultProps = { denominator: 10, buttonStyle: 'tablePageButton' };

Paginate.propTypes = {
  currentPage: PropTypes.number,
  totalCount: PropTypes.number,
  getListPage: PropTypes.func,
  list: PropTypes.object,
  denominator: PropTypes.number,
  buttonStyle: PropTypes.string,
};

export default Paginate;



// WEBPACK FOOTER //
// ./client/app/shared/components/Pagination/index.jsx